<template>
  <div class="icon-section">
    <MyAppIcon v-for="(item,index) in icons" :key="item.id"
               :item="item" :cell="cell" :order="index"></MyAppIcon>
  </div>
</template>

<script>
import MyAppIcon from "@/views/MyAppIcon.vue";

export default {
  name: 'MyAppGrid',
  components: {
    MyAppIcon
  },
  data() {
    return {
      cell: {//每个单元格大小
        height: 120,
        width: 120
      },
      isSimpleRoute:false,
      isSuperAdmin:false,
      isDirectGroup:false,
      businessUnitId: ''
    }
  },
  computed: {
    icons() {
      let list = this.$store.state.core.applications;
      if(this.isSuperAdmin === true){
        return list;
      }
      let data = [];
      for (let item of list) {
        // if(item.id === 'bu_finance_center' && !this.isDirectGroup){
        //   this.$message.error('您没有权限访问此功能');
        //   continue;
        // }
        if(this.isSimpleRoute === true){
          if(item.id !== 'bu_repair_center' && item.id !== 'bu_cs_center'){
            data.push({...item});
          }
        }else{
          console.log('item.id',item.id);
          if(item.id !== 'bu_repair_center_simple_repair'){
            data.push({...item});
          }
          if (item.id === 'bu_repair_center_simple_repair' && this.businessUnitId === 'WH001'){
            data.push({...item});
          }
        }
      }
      return data;
    }
  },
  async created() {
    await this.getIsSimpleRoute();
    await this.getIsDirectGroup();
  },

  methods: {
    async getIsSimpleRoute(){
      let data = await this.$http('buItemSimpleService.getIsSimpleRoute',{});
      this.isSimpleRoute = data.isSimpleRoute;
      this.isSuperAdmin = data.isSuperAdmin;
      this.businessUnitId = data.business_unit_id;
    },
    async getIsDirectGroup(){
      let data = await this.$http('buRoleService.getIsDirectGroup',{});
      this.isDirectGroup = data?.isDirectGroup;
    }
  },
};
</script>

<style lang="less" scoped>

.icon-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

</style>
